'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');

/**
 * 라디오 버튼 그룹을 구성하는 컴포넌트입니다.
 *
 * @param {Object} props
 * @param {RadioItemProps[]} props.data - 라디오 버튼 아이템들의 데이터 배열 ({label, value, description, onChange, className, RadioClassName}[])
 * @param {string} props.name - 라디오 그룹의 name 속성
 * @param {string} props.selectedValue - 현재 선택된 라디오 버튼의 값
 * @param {Function} props.onChange - 라디오 버튼 선택 변경 시 호출되는 핸들러 함수
 * @param {Function} props.children - 각 라디오 버튼 아이템을 렌더링하는 렌더 프롭 함수
 * @param {boolean} [props.isError] - 에러 상태 여부
 * @param {boolean} [props.isDisabled] - 비활성화 상태 여부
 *
 * @example
 * ```tsx
 * const radioItems = [
 *   { label: '옵션 1', value: '1', description: '첫 번째 옵션입니다.' },
 *   { label: '옵션 2', value: '2', description: '두 번째 옵션입니다.' }
 * ];
 *
 * <RadioGroup
 *   data={radioItems}
 *   name="options"
 *   selectedValue="1"
 *   onChange={(e) => console.log(e.target.value)}
 * >
 *   {(item) => (
 *     <RadioButton
 *       label={item.label}
 *       value={item.value}
 *       description={item.description}
 *       isSelected={item.isSelected}
 *       onChange={item.onChange}
 *     />
 *   )}
 * </RadioGroup>
 * ```
 */ const RadioGroup = ({ data, selectedValue, children, onChange, isError, isDisabled })=>{
    return jsxRuntime.jsx(jsxRuntime.Fragment, {
        children: data.map((item)=>{
            const isSelected = selectedValue === item.value;
            return jsxRuntime.jsx(react.Fragment, {
                children: children(Object.assign(Object.assign({}, item), {
                    onChange,
                    isError,
                    isDisabled,
                    isSelected
                }))
            }, item.value);
        })
    });
};

module.exports = RadioGroup;
